import type { ComponentPropsWithoutRef } from "react";
import type { Control } from "react-hook-form";
import { t } from "ttag";

import { Form, Select } from "@/shared/ui";
import { generateDurationIntervalOptions } from "@/shared/utils";
import type { AdminSession } from "../models";

const options = generateDurationIntervalOptions();

type FieldValue = Pick<AdminSession, "duration">;

type SessionDurationControl<T> = T extends FieldValue ? Control<T> : never;

type SessionDurationFieldProps<T extends FieldValue> = ComponentPropsWithoutRef<
  typeof Form.Item
> & {
  control: SessionDurationControl<T>;
};

export const SessionDurationField = <T extends FieldValue>({
  control,
  ...props
}: SessionDurationFieldProps<T>) => {
  return (
    <Form.Field
      control={control}
      name="duration"
      render={({ field: { value, ...field } }) => (
        <Form.Item {...props}>
          <Form.Label aria-required>{t`Duration`}</Form.Label>
          <Form.Control>
            <Select options={options} value={value ?? ""} {...field} />
          </Form.Control>
          <Form.Message compact={false} />
        </Form.Item>
      )}
    />
  );
};
